module.exports = __webpack_public_path__ + "static/media/Sameer.016ff662.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/Sameer.webp
// module id = 293
// module chunks = 0